import {Stack} from 'react-bootstrap';
import {CodeTipPanel, CODING_TIPS, CODING_TIPS_SPANISH} from './CodingTips';
import {KarelLoadingAnimation} from './KarelLoadingAnimation';
import {useWindowSize} from 'react-use-size';
import {useIsMobile} from 'utils/general';
import {useRef} from 'react';
import {checkIsSpanishCourse} from 'utils/courseUtils';
import {useCourseIdWithoutFallback} from 'hooks/router/useUrlParams';
import {CourseId} from 'types/common';

// Constants from your existing code
const HIDE_TIP_HEIGHT = 400;
const DESKTOP_LOADING_ANIMATION_SCALE = 0.6;
const MOBILE_LOADING_ANIMATION_SCALE = 0.4;

function getRandomTip(courseId: CourseId): string {
  const codingTips = checkIsSpanishCourse(courseId)
    ? CODING_TIPS_SPANISH
    : CODING_TIPS;
  const codingTipIdx = Math.floor(Math.random() * codingTips.length);
  return codingTips[codingTipIdx];
}

export const StandardLoading = () => {
  const {height} = useWindowSize();
  const isMobile = useIsMobile();
  // eslint-disable-next-line prefer-const -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  let courseId = useCourseIdWithoutFallback();
  // eslint-disable-next-line @eslint-react/naming-convention/ref-name -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  const codingTip = useRef(getRandomTip(courseId));

  const shouldHideTip = height < HIDE_TIP_HEIGHT;
  const loadingText = checkIsSpanishCourse(courseId)
    ? 'Cargando...'
    : 'Loading...';
  const codingTipText = checkIsSpanishCourse(courseId)
    ? 'Consejo de código pro'
    : 'Coding Pro Tip';

  const animationScale = isMobile
    ? MOBILE_LOADING_ANIMATION_SCALE
    : DESKTOP_LOADING_ANIMATION_SCALE;

  return (
    <Stack className="align-items-center justify-content-center">
      <h1 className="text-center">{loadingText}</h1>
      <KarelLoadingAnimation scale={animationScale} />
      {!shouldHideTip && (
        <CodeTipPanel>
          <b>{codingTipText}:</b> {codingTip.current}
        </CodeTipPanel>
      )}
    </Stack>
  );
};
